import moment from 'moment';
import protoManager from './proto-manager.js';

import { getOptionalNumberStr            } from './util.js';
import { getMomentStr                    } from './util.js';
import { getMomentMinStr                 } from './util.js';
import { getOptionalMomentStr            } from './util.js';
import { getOptionalMomentStrWithDefault } from './util.js';
import { getOptionalDashMomentStr        } from './util.js';
import { getOptionalTextMomentStr        } from './util.js';
import { getDurationStr                  } from './util.js';
import { getDurationStrForBilling        } from './util.js';
import { getRoleName                     } from './util.js';
import { getUserFullName                 } from './util.js';
import { getStrWithLowFirstLetter        } from './util.js';
import { getShortSKU                     } from './util.js';
import { getPlatformName                 } from './util.js';
import { getLangStrCode                  } from './util.js';
import { getLangNameEn                   } from './util.js';
import { getLangNameRu                   } from './util.js';
import { getSignedNumberStr              } from './util.js';
import { convertVersionCodeToStr         } from './util.js';
import { convertOptionalVersionCodeToStr } from './util.js';
import { getProtoAlias                   } from './util.js';
import { getHumanProtoAlias              } from './util.js';
import { getFormattedNumber              } from './util.js';
import { getFormattedDifference          } from './util.js';
import { getBoolStr                      } from './util.js';

import { getEnumPlayerRFMCategoryName } from './autogen/bundle.js';

export default {
  getLangStrCode,
  getOptionalNumberStr,

  getHumanDate(stamp) {
    return moment(stamp*1000).format('DD/MM/YYYY hh:mm:ss a');
  },

  getMomentStr,
  getMomentMinStr,

  getOptionalMomentStr,
  getOptionalMomentStrWithDefault,

  getOptionalDashMomentStr,
  getOptionalTextMomentStr,

  getRelativeTime(stamp) {
    if(stamp == 0)
      return 'Very long time ago';
    return moment(stamp*1000).fromNow();
  },

  getPlatformName,

  getProtoAlias,
  getHumanProtoAlias,
  getProtoStr,
  getOptionalProtoStr,

  getDurationStr,
  getDurationStrForBilling,

  getOptionalStr(value) {
    if(value === null) {
      return 'unknown';
    }
    return value;
  },

  getOptionalStringStr(s) {
    const defaultValue = 'unknown';
    return getOptionalStringDefaultStr(s, defaultValue);
  },

  getOptionalStringDefaultStr,

  getFormattedNumber,
  getFormattedDifference,
  getSignedNumberStr,

  getShortBillingServiceId(id) {
    return getShortSKU(id);
  },

  getQAUserIdTypeStr(idType) {
    switch(idType) {
      case 1: return 'Player ID';
      case 2: return 'Facebook ID';
      case 3: return 'Ads ID';
      default:
        return `Unknown id type (${idType})`;
    }
  },

  getLangNameEn,
  getLangNameRu,

  getOfferStateName(stateCode) {
    // see EnumSpecialOfferState
    switch(stateCode) {
      case 0: return 'none';
      case 1: return 'running';
      case 2: return 'finished purchased';
      case 3: return 'finished ignored';
      case 4: return 'incoming';

      default:
        return `Unknown state code (${stateCode})`;
    }
  },

  getPlayerRFMCategoryNameShort(rfmCode) {
    if(rfmCode === 0) {
      return '?';
    }
    const categoryName = getEnumPlayerRFMCategoryName(rfmCode);
    return getStrWithLowFirstLetter(categoryName);
  },

  numberToBoolStr(n) {
    if(n === 0) {
      return 'false';
    }
    return 'true';
  },

  getRoleName,
  getUserFullName,

  convertVersionCodeToStr,
  convertOptionalVersionCodeToStr,

  getBoolStr,
};

function getOptionalStringDefaultStr(s, defaultValue) {
  if(s === undefined) {
    return defaultValue;
  }
  if(s === null) {
    return defaultValue;
  }
  if(s.length === 0) {
    return defaultValue;
  }
  return s;
}

function getProtoStr(protoId) {
  const alias = protoManager.getAlias(protoId);
  return alias + ' (' + protoId + ')';
}

// Param protoId can be 0.
function getOptionalProtoStr(protoId) {
  if(protoId === 0) {
    return '';
  }
  return getProtoStr(protoId);
}
